import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "../styles/LearnerDashboard.css";
import { learnerMenuItems } from "../components/TeacherMenuItems";

import Videos from "../components/Videos";
import { getToken } from "../Storage/Storage";

import { allYouTubeVideos } from "../Services/AllServices";

// import tutorials from "../images/tutorials.png";
// import history from "../images/history.png";
import TeacherStudentHeader from "../components/TeacherStudentHeader";
import AccessTokenModal from "../components/AccessTokenModal";

const LearnerDashboard = () => {
  const [activeItem, setActiveItem] = useState("home");
  const [isVideoMode, setIsVideoMode] = useState(true);
  const [searchQuery, setSearchQuery] = useState(""); // Store search query
  const [videoData, setVideoData] = useState([]);
  const [setToken] = useState(null);
  const [setOpen] = useState(false);

  // Store dynamic video data

  const navigate = useNavigate(); // Initialize useNavigate

  // Fetch dynamic video data from the API
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        await allYouTubeVideos((response) => {
          if (Array.isArray(response.data)) {
            setVideoData(response.data);
          }
        });
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    };

    fetchVideos(); // Trigger the fetch on component mount
  }, []);

  const toggleMode = (mode) => {
    setIsVideoMode(mode);
  };

  const resetSearch = () => {
    setSearchQuery(""); // Reset the search query
  };

  const getHeaderVisibility = () => {
    if (activeItem === "home" || activeItem === "") {
      return { showSearch: true, showToggle: true, showUserProfile: true };
    } else if (activeItem === "feedback") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    }
    return { showSearch: false, showToggle: false, showUserProfile: true };
  };

  const handleActiveItemChange = (item) => {
    setActiveItem(item); // Update active item

    // Navigate to the correct route
    if (item === "feedback") {
      navigate("/learner/feedback"); // Navigate to feedback page
    } else if (item === "home") {
      navigate("/learner"); // Navigate to home page
    } else if (item === "Download") {
      navigate("/learner/download"); // Navigate to download page
    }

    resetSearch(); // Reset search whenever a new section is selected
  };

  const filteredVideos = videoData.filter((video) =>
    video.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleOpenModal = async () => {
    const t = await getToken(); // Fetch token
    if (t) {
      setToken(t); // Set token
      setOpen(true); // Open modal
    }
  };

  const { showSearch, showToggle, showUserProfile } = getHeaderVisibility();

  return (
    <div className="dashboard">
      <TeacherStudentHeader
        isVideoMode={isVideoMode}
        toggleMode={toggleMode}
        showSearch={showSearch}
        showToggle={showToggle}
        showUserProfile={showUserProfile}
        searchQuery={searchQuery}
        // onSearch={handleSearch}
        teacherMenuItems={learnerMenuItems}
        activeItem={activeItem} // Pass activeItem
        setActiveItem={handleActiveItemChange}
        onOpenWebVersionModal={handleOpenModal} // Pass setActiveItem
      />
      <main className="main-content">
        {/* <Sidebar
          activeItem={activeItem}
          setActiveItem={handleActiveItemChange}
          menuItems={learnerMenuItems}
          resetSearch={resetSearch}
        /> */}

        <div className="content">
          <Videos videoData={filteredVideos} />
        </div>
      </main>

      <AccessTokenModal />
    </div>
  );
};

export default LearnerDashboard;
